import React from 'react';

import { type SsoConnection } from '@column/api';
import { Badge, cn } from '@column/ui';

import { UnderlineLink } from '~/elements/UnderlineLink';

import { SSO_REDIRECT_URI, SSO_SCOPES } from './constants';
import { CopyButton } from './CopyButton';

export const ServiceProviderDetails: React.FC<{ connection?: SsoConnection }> = ({ connection }) => (
  <div className="grid gap-2">
    <div className="overflow-hidden rounded-lg bg-gray-25 ring-1 ring-black/5 dark:bg-white/[0.02] dark:ring-white/10">
      <div className="grid grid-cols-2 divide-x divide-gray-100 dark:divide-white/[0.08]">
        <div className="grid min-w-0 gap-1 px-4 py-3">
          <span className="text-xs text-muted-foreground">Grant Type</span>
          <span className="text-sm font-medium text-foreground">Authorization Code</span>
        </div>
        <div className="grid min-w-0 gap-1 px-4 py-3">
          <span className="text-xs text-muted-foreground">Scopes</span>
          <div className="flex flex-wrap gap-1">
            {SSO_SCOPES.map((scope) => (
              <Badge key={scope} variant="outline" className="font-mono">
                {scope}
              </Badge>
            ))}
          </div>
        </div>
      </div>
      {[
        { label: 'Redirect URI', value: connection?.redirect_uri ?? SSO_REDIRECT_URI },
        ...(connection ? [{ label: 'Initiate Login URI', value: connection.initiate_login_uri, isWrapped: true }] : []),
      ].map(({ label, value, isWrapped }) => (
        <div
          key={label}
          className="flex items-center gap-3 border-t border-gray-100 px-4 py-3 dark:border-white/[0.08]"
        >
          <div className="grid min-w-0 flex-1 gap-1">
            <span className="text-xs text-muted-foreground">{label}</span>
            <span className={cn('text-sm', isWrapped ? 'break-all' : 'truncate')}>
              <UnderlineLink href={value} newTab>
                {value}
              </UnderlineLink>
            </span>
          </div>
          <CopyButton label={label} value={value} />
        </div>
      ))}
    </div>
  </div>
);
